const menuButton = document.querySelector('.mobile-menu-toggle');
const menu = document.querySelector('#MobileMenu');
const headerShell = document.querySelector('.header-shell');
const inertRegions = document.querySelectorAll('#MainContent, .site-footer');
function positionMenu() {
  if (!menu || !headerShell) return;
  const header = headerShell.querySelector('.site-header');
  const bottom = Math.max(0, header.getBoundingClientRect().bottom);
  menu.style.top = bottom + 'px';
  menu.style.height = 'calc(100dvh - ' + bottom + 'px)';
}
function closeMenu(restoreFocus = false) {
  if (!menuButton || !menu) return;
  const wasOpen = !menu.hidden;
  menu.hidden = true;
  menuButton.setAttribute('aria-expanded', 'false');
  menuButton.setAttribute('aria-label', 'Open navigation');
  document.body.classList.remove('menu-open');
  inertRegions.forEach(region => { region.inert = false; });
  if (restoreFocus && wasOpen) menuButton.focus();
}
menuButton?.addEventListener('click', () => {
  const open = menu.hidden;
  if (!open) { closeMenu(true); return; }
  positionMenu();
  menu.hidden = false;
  menuButton.setAttribute('aria-expanded', 'true');
  menuButton.setAttribute('aria-label', 'Close navigation');
  document.body.classList.add('menu-open');
  inertRegions.forEach(region => { region.inert = true; });
  menu.querySelector('a')?.focus();
});
menu?.querySelectorAll('a').forEach(a => a.addEventListener('click', () => closeMenu()));
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeMenu(true);
  if (e.key !== 'Tab' || !menu || menu.hidden) return;
  const focusable = [...headerShell.querySelectorAll('a[href], button')].filter(el => !el.closest('dialog, .desktop-nav') && !el.disabled);
  const first = focusable[0], last = focusable.at(-1);
  if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
  else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
});
matchMedia('(min-width:801px)').addEventListener('change', e => { if(e.matches) closeMenu(true); });
addEventListener('resize', () => { if (menu && !menu.hidden) positionMenu(); });
function setHeaderPosition() {
  const announcement = headerShell?.querySelector('.announcement');
  document.documentElement.style.setProperty('--announcement-height', (announcement?.offsetHeight || 0) + 'px');
  document.documentElement.style.setProperty('--header-height', ((headerShell?.querySelector('.site-header')?.offsetHeight || 0) + (headerShell?.querySelector('.vehicle-garage')?.offsetHeight || 0)) + 'px');
}
setHeaderPosition();
if ('ResizeObserver' in window && headerShell) new ResizeObserver(setHeaderPosition).observe(headerShell);
let headerFrame = 0;
addEventListener('scroll', () => {
  if (headerFrame) return;
  headerFrame = requestAnimationFrame(() => {
    headerShell?.classList.toggle('is-scrolled', scrollY > 100);
    headerFrame = 0;
  });
}, { passive: true });
const searchDialog = document.querySelector('#SearchDialog');
document.querySelectorAll('[data-search-open]').forEach(button => button.addEventListener('click', () => { closeMenu(); searchDialog.showModal(); document.querySelector('#SiteSearch').focus(); }));
document.querySelectorAll('[data-dialog-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
document.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } }));
document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => { if (!document.documentElement.dataset.preview) select.form.requestSubmit(); }));
document.querySelectorAll('[data-product-thumbnail]').forEach(button => button.addEventListener('click', () => { const img = document.querySelector('#ProductImage'); if(img) {img.src = button.dataset.productThumbnail; img.removeAttribute('srcset');} }));
document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option=event.target.selectedOptions[0];
  const product=event.target.closest('.product-page');
  if (!option || !product) return;
  const price=product.querySelector('[data-product-price]');
  const sku=product.querySelector('[data-product-sku]');
  if(price) price.textContent=option.dataset.price || '';
  if(sku) sku.textContent='SKU: '+(option.dataset.sku || '');
  const button=event.target.form?.querySelector('[data-add-button]');
  if(button){button.disabled=option.dataset.available!=='true';button.querySelector('span').textContent=button.disabled?'UNAVAILABLE':'ADD TO BAG';}
  if(option.dataset.image){const image=product.querySelector('#ProductImage');if(image){image.src=option.dataset.image;image.removeAttribute('srcset');}}
  const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState(null,'',url);
});

// Progressive enhancement: content remains visible without JavaScript or motion support.
const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
let revealObserver;
function enableScrollReveals(scope=document){
  if(reducedMotion.matches||!('IntersectionObserver' in window))return;
  revealObserver??=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-revealed');revealObserver.unobserve(entry.target);}});
  },{threshold:0,rootMargin:'0px 0px -32px 0px'});
  const targets=scope.querySelectorAll('.section-heading,.category-card,.product-card,.feature-story-copy,.feature-story-image,.footer-top>div,.product-main-image,.product-details');
  targets.forEach(element=>{
    if(element.hidden||element.dataset.revealReady)return;
    const bounds=element.getBoundingClientRect();
    if(bounds.top<innerHeight-32||bounds.left>innerWidth||bounds.right<0)return;
    element.dataset.revealReady='true';
    const siblings=Array.from(element.parentElement.children);
    const index=element.matches('.category-card,.product-card')?siblings.indexOf(element)%4:0;
    element.style.setProperty('--reveal-delay',index*80+'ms');
    element.classList.add('scroll-reveal');
    revealObserver.observe(element);
  });
}
enableScrollReveals();
reducedMotion.addEventListener('change',event=>{if(event.matches){revealObserver?.disconnect();document.querySelectorAll('.scroll-reveal').forEach(el=>el.classList.add('is-revealed'));}else enableScrollReveals();});
document.addEventListener('shopify:section:load',event=>enableScrollReveals(event.target));
// Never hide a keyboard destination while waiting for it to enter the viewport.
document.addEventListener('focusin',event=>{const reveal=event.target.closest('.scroll-reveal');if(reveal){reveal.classList.add('is-revealed');revealObserver?.unobserve(reveal);}});
addEventListener('pageshow',event=>{if(event.persisted)document.querySelectorAll('.scroll-reveal').forEach(el=>el.classList.add('is-revealed'));});
